import { SnackbarEffects } from './snackbar.effects';

export const effects = [SnackbarEffects];
